// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"95aed176","81":"4207d8e9","106":"77e68822","143":"b1ce934d","199":"984dd0a1","204":"f1bf8b11","449":"8a351b16","477":"551e5963","575":"f5e3eb8b","580":"0806eb9f","667":"1656889c","713":"e7844129","750":"74f917a3","857":"c1c21f2b","948":"829b83db"}[chunkId] + ".chunk.js";
};